import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { FeatureRedFishProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/features/redfish/FeatureRedFishProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Point } from "pixi.js";
export class FeatureRedFishLandscapeProperties extends FeatureRedFishProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.logoProperties = new SpriteProperties(GameStyle.LOGO, GameStyle.MODULE, new Point(1509, 133), new Point(0.24, 0.24), new Point(0, 0));
    }
}
